<template>
  <div class="sub-agent-list-page">
    <div class="custom-nav-block" :style="`padding-top:${topBarHeight}px`">
      <van-nav-bar title="" left-arrow @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="../../images/arrow-l.webp" alt="" />
          <!-- Sub-agent Performance -->
          <span class="tit-left">{{ $t('lang.Invite.k094') }}</span>
        </template>
      </van-nav-bar>
    </div>
    <div class="page-content" @scroll.passive="handleListScroll">
      <div class="time-tab-wrap">
        <div ref="timeTabList" class="time-switch-tab">
          <div
            v-for="(tab, index) in timeTabs"
            :key="tab.key"
            :ref="`timeTab-${index}`"
            class="time-tab"
            :class="{ 'active-tab': timeTabIndex === index }"
            @click="handleTimeTab(index)"
          >
            {{ $t(tab.labelKey) }}
          </div>
        </div>
      </div>
      <div class="list-search">
        <input v-model="searchId" maxlength="30" :placeholder="$t('lang.Invite.k088')" />
        <div class="search-divider"></div>
        <div class="search-btn" @click="handleListSearch">{{ $t('lang.Invite.k084') }}</div>
      </div>
      <div class="stat-cards three-cols">
        <div class="stat-card">
          <div class="stat-value">{{ newHostCount }}</div>
          <div class="stat-label">
            <p>{{ $t('lang.Invite.k091') }}</p>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ hasInviteAgentCount }}</div>
          <div class="stat-label">
            <p>{{ $t('lang.Invite.k095') }}</p>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-value">{{ noInviteAgentCount }}</div>
          <div class="stat-label">
            <p>{{ $t('lang.Invite.k096') }}</p>
          </div>
        </div>
      </div>
      <div class="data-table">
        <div class="table-header">
          <div class="th th-agent">{{ $t('lang.Invite.k089') }}</div>
          <div class="th">{{ $t('lang.Invite.k091') }}</div>
          <div class="th">{{ $t('lang.Invite.k011') }}</div>
        </div>
        <div v-for="item in listData" :key="item.presentId" class="table-row">
          <div class="td td-agent">
            <div class="agent-name-row">
              <span class="agent-name">{{ item.nickname }}</span>
              <img v-if="item.locationFlag" class="country-icon" :src="item.locationFlag | imgPath" alt="" />
            </div>
            <div class="agent-id-row" @click="handleCopyId(item.presentId)">
              <span>ID:{{ item.presentId }}</span>
              <img class="copy-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/copy-light.webp" alt="" />
            </div>
          </div>
          <div class="td td-center">{{ item.newHostess }}</div>
          <div class="td td-center">{{ item.totalHostess }}</div>
        </div>
        <div v-if="!listLoading && !listData.length" class="table-empty"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { apiFetchSubAgentInvite } from '@/api/invite'
import subAgentListMixin from './hooks/sub-agent-list.mixin.js'
import { INVITE_DATA_TYPE, TIME_TABS_INVITE, buildInviteParams, mapSubAgentStatItem } from './utils/index'
export default {
  name: 'SubAgentPerformancePage',
  mixins: [subAgentListMixin],
  data() {
    const query = this.$route.query
    return {
      topBarHeight: query.statusBarHeight || 38,
      searchId: '',
      timeTabIndex: Number(query.timeTabIndex) || 0,
      timeTabs: TIME_TABS_INVITE,
      hasInviteAgentCount: 0,
      newHostCount: 0,
      noInviteAgentCount: 0,
    }
  },
  watch: {
    timeTabIndex() {
      this.resetListState()
      this.loadListData()
    },
  },
  created() {
    this.loadListData()
  },
  methods: {
    loadListData() {
      if (this.listLoading || this.listFinished) return
      this.listLoading = true
      apiFetchSubAgentInvite(
        buildInviteParams({
          timeTabIndex: this.timeTabIndex,
          dataType: INVITE_DATA_TYPE.PERFORMANCE,
          offset: this.listOffset,
          limit: this.listLimit,
          presentId: this.searchPresentId,
        })
      )
        .then((res) => {
          const items = ((res && res.subAgentPerforms) || []).map((item) => mapSubAgentStatItem(item))
          this.hasInviteAgentCount = (res && res.hasInviteAgentCount) ?? 0
          this.newHostCount = (res && res.newHostCount) ?? 0
          this.noInviteAgentCount = (res && res.noInviteAgentCount) ?? 0
          this.listData = this.listData.concat(items)
          this.listOffset = this.listData.length
          this.listFinished = items.length < this.listLimit
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleCopyId(id) {
      this.handleCopy(id, this.$t('lang.BaseCommon.k071'))
    },
    handleTimeTab(index) {
      this.timeTabIndex = index
      this.$nextTick(() => {
        const tabList = this.$refs.timeTabList
        const tabRef = this.$refs[`timeTab-${index}`]
        const tabEl = Array.isArray(tabRef) ? tabRef[0] : tabRef
        if (tabList && tabEl) {
          const listRect = tabList.getBoundingClientRect()
          const tabRect = tabEl.getBoundingClientRect()
          const offset = tabRect.left - listRect.left - (listRect.width - tabRect.width) / 2
          tabList.scrollTo({ left: tabList.scrollLeft + offset, behavior: 'smooth' })
        }
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.sub-agent-list-page {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #fefefe;

  .custom-nav-block {
    flex-shrink: 0;
    background: #fefefe;

    .van-nav-bar {
      background: #fefefe;

      .tit-left {
        font-family: 'InterTight-Medium', var(--string-font);
        font-size: var(--fs-20);
        line-height: var(--lh-title-24);
        color: #333333;
        font-weight: var(--fw-500);
      }

      .left-nav {
        width: 20px;
        height: 20px;
      }
    }
  }

  .page-content {
    flex: 1;
    padding: 16px;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    .time-tab-wrap {
      position: relative;
      width: 100%;

      .time-switch-tab {
        display: flex;
        align-items: center;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        scrollbar-width: none;

        &::-webkit-scrollbar {
          display: none;
        }

        .time-tab {
          flex-shrink: 0;
          padding: 8px 16px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-title-20);
          color: #b2b2b2;
          white-space: nowrap;
          text-align: center;

          &.active-tab {
            background: #f1e8d9;
            border-radius: 36px;
            color: #925e0d;
          }
        }
      }
    }

    .list-search {
      display: flex;
      align-items: center;
      width: 100%;
      margin: 12px 0 0;
      background: #f6f6f5;
      border-radius: 8px;
      overflow: hidden;

      input {
        flex: 1;
        min-width: 0;
        height: 44px;
        padding: 0 12px;
        border: none;
        background: transparent;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-body-20);
        color: #333333;

        &::placeholder {
          color: #cccccc;
        }
      }

      .search-divider {
        width: 1px;
        height: 16px;
        background: #d9d9d9;
        flex-shrink: 0;
      }

      .search-btn {
        padding: 12px;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-14);
        line-height: var(--lh-body-20);
        color: #cccccc;
        white-space: nowrap;
      }
    }

    .stat-cards {
      margin-top: 8px;
      display: flex;

      &.three-cols {
        .stat-card + .stat-card {
          margin-inline-start: 8px;
        }

        .stat-card {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          min-height: 86px;
          padding: 13px 14px;
          background: linear-gradient(180deg, #fff0d9 0%, #fefcf8 100%);
          border-radius: 12px;
          box-sizing: border-box;

          .stat-label {
            margin-top: 4px;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-12);
            line-height: var(--lh-body-18);
            color: #ad8a55;

            p {
              margin: 0;
            }
          }

          .stat-value {
            flex: 1;
            font-family: var(--number-font);
            font-weight: var(--fw-400);
            font-size: 24px;
            line-height: 32px;
            color: #925e0d;
          }
        }
      }
    }

    .data-table {
      border: 2px solid #f9f8f6;
      border-radius: 8px;
      overflow: hidden;
      width: 100%;
      margin-top: 8px;
      background: transparent;

      .table-header {
        display: grid;
        grid-template-columns: 38% 30% 32%;

        .th {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          min-width: 0;
          padding: 8px 4px;
          background: #f9f8f6;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-title-20);
          color: #925e0d;
          text-align: center;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;

          &.th-agent {
            border-inline-end: 1px solid #edeae3;
          }

          &:nth-child(2) {
            border-inline-start: 1px solid #edeae3;
            border-inline-end: 1px solid #edeae3;
          }

          &:nth-child(3) {
            border-inline-start: 1px solid #edeae3;
          }
        }
      }

      .table-row {
        display: grid;
        grid-template-columns: 38% 30% 32%;
      }

      .td {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 4px;
        border-bottom: 1px solid #f9f8f6;
        font-family: var(--string-font);
        font-weight: var(--fw-400);
        font-size: var(--fs-12);
        line-height: var(--lh-label-16);
        color: #333333;
        align-self: stretch;

        &.td-agent {
          flex-direction: column;
          align-items: start;
          padding: 12px 6px;

          .agent-id-row {
            margin-top: 8px;
            display: inline-flex;
            align-items: center;
            max-width: 100%;
            color: #b2b2b2;

            span {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
            }

            .copy-icon {
              margin-inline-start: 2px;
              width: 16px;
              height: 16px;
              flex-shrink: 0;
            }
          }

          .agent-name-row {
            display: inline-flex;
            align-items: center;
            max-width: 100%;
            min-width: 0;

            .country-icon {
              margin-inline-start: 2px;
              width: 16px;
              height: 16px;
              border-radius: 50%;
              flex-shrink: 0;
            }

            .agent-name {
              flex: 0 1 auto;
              max-width: 80px;
              font-size: var(--fs-14);
              line-height: var(--lh-title-20);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }

        &.td-center {
          min-width: 0;
          flex-wrap: wrap;
          align-content: center;
          text-align: center;
          white-space: normal;
          word-break: break-word;
          overflow-wrap: break-word;
        }
      }

      .table-row:last-child .td {
        border-bottom: none;
      }

      .table-empty {
        min-height: 120px;
        background: #fefefe;
      }
    }
  }
}
</style>
